// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-products-container-k9m_p {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 10px;
}

.customer-products-table_container-zwDmp {
  padding: 0px 10px;
}

.customer-products-tableHeader_cellContent-Tcxnp {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}

.customer-products-addButton_base-CNQQc {
  width: 152px;
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/customer-products/products.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-left: 10px;\n}\n\n.table_container {\n  padding: 0px 10px;\n}\n\n.tableHeader_cellContent {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.addButton_base {\n  width: 152px;\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `customer-products-container-k9m_p`,
	"table_container": `customer-products-table_container-zwDmp`,
	"tableHeader_cellContent": `customer-products-tableHeader_cellContent-Tcxnp`,
	"addButton_base": `customer-products-addButton_base-CNQQc`
};
export default ___CSS_LOADER_EXPORT___;
